<template>
  <!-- 侧边功能区-->
  <div class="side_bars">
    <img 
      src="http://img.wish.hebyun.com.cn/images/share_icon.png"
      @click="share"
    />
    <img
      src="http://img.wish.hebyun.com.cn/images/return_con.png"
      v-if="isFirstPage == false"
      @click="goback"
    />
  </div>
</template>

<script>
export default {
  name: "slideBar",
  props: ["isFirstPage"],
  methods: {
    goback() {
      this.$router.go(-1);
    },

    share() {
      var url = window.location.href;

      var msg = {
        shareTitle: "党员微心愿",
        shareSummary: "党员微心愿",
        shareUrl: url,
        shareImage:
          "http://pic1.hebei.com.cn/003/022/280/00302228046_c01a998c.jpg",
      };
      const u = navigator.userAgent,
        app = navigator.appVersion;
      console.log(app);
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        window.webkit.messageHandlers.nativeShare.postMessage(
          JSON.stringify(msg)
        );
      } else {
        window.jsInterface.nativeShare(JSON.stringify(msg));
      }
    },
  },
};
</script>

<style lang="scss">
// 侧边功能区
.side_bars {
  position: fixed;
  right: -5px;
  bottom: 320px;
  z-index: 10000;
  img {
    display: block;
    width: 45px;
    height: 45px;
    margin-bottom: 7px;
  }
}
</style>
